import { gql } from '@apollo/client';
import { Badge } from '@apollo/orbit';
import React from 'react';

import { SchemaHash } from 'src/app/graph/launchesPage/launchHistory/launchDetails/launchInfo/SchemaHash';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { isMinLengthArray } from 'src/lib/isMinLengthArray';
import { useLDFlag } from 'src/lib/launchDarkly';

export const FilterBuildInputsFragment = gql`
  fragment FilterBuildInputsFragment on FilterBuildInputs {
    supergraphSchemaHash
    include
    exclude
    hideUnreachableTypes
  }
`;

interface Props {
  buildInputs: GraphQLTypes.FilterBuildInputsFragment;
}

export const FilterBuildInputs = ({ buildInputs }: Props) => {
  const showHideUnreachableTypes = useLDFlag(
    'mercury_show_hide_unreachable_types_toggle',
  );
  return (
    <>
      {/* Schema hash */}
      <div className="mb-6">
        <b className="mr-4">Schema Hash</b>
        <SchemaHash hash={buildInputs.supergraphSchemaHash} />
      </div>

      {/* Exclude filters */}
      <div className="mb-2">
        <b className="mr-4">Exclude Filters</b>
        <span className="text-sm text-secondary">
          Schema elements with the following tags will be <b>excluded</b>.
        </span>
      </div>
      <div className="flex flex-wrap text-sm">
        {isMinLengthArray(1, buildInputs.exclude)
          ? buildInputs.exclude?.map((tag) => (
              <Badge key={tag} className="mr-2">
                {tag}
              </Badge>
            ))
          : 'No filters configured.'}
      </div>

      {/* Include filters */}
      <div className="mb-2 mt-6">
        <b className="mr-4">Include Filters</b>
        <span className="text-sm text-secondary">
          Schema elements with the following tags will be <b>included</b>.
        </span>
      </div>
      <div className="flex flex-wrap text-sm">
        {isMinLengthArray(1, buildInputs.include)
          ? buildInputs.include?.map((tag) => (
              <Badge key={tag} className="mr-2">
                {tag}
              </Badge>
            ))
          : 'No filters configured.'}
      </div>

      {/* Hide unreachable types */}
      {showHideUnreachableTypes && (
        <>
          <div className="mb-2 mt-6">
            <b className="mr-4">Hide unreachable types</b>
            <span className="text-sm text-secondary">
              Types considered unreachable will be <b>excluded</b>.
            </span>
          </div>
          <div className="text-sm">
            <span className="rounded-sm border border-primary bg-silver px-2 py-px text-sm font-semibold text-secondary">
              {buildInputs.hideUnreachableTypes.toString()}
            </span>
          </div>
        </>
      )}
    </>
  );
};
